// extracted by mini-css-extract-plugin
export default {"container":"phonebook_container__mKqp5","contacts":"phonebook_contacts__VLBmt"};